import type {
  ACCESS_TOKEN,
  DEV_ACCESS_TOKEN,
  DEV_MODE,
  PROD_MODE,
  UNKNOWN_MODE,
} from '@app/constants';
import type { NNotificationProvider } from '@app/providers/NotificationProvider/NotificationProvider.types';
import type {
  NConstants,
  NClientServices,
  NAuth,
  NBranches,
  NDictionaries,
  NSmallGlobalEntities,
} from '@app/types';

import type { NotificationInstance } from 'antd/es/notification/interface';
import type { BaseOptionType } from 'antd/es/select';

export namespace NUtils {
  export type CreateUserPrint = (args: {
    userId: NAuth.User['userId'];
    database: NAuth.User['database'];
    activeBranchId: NAuth.User['activeBranchId'];
  }) => {
    UserId: NAuth.User['userId'];
    Database: NAuth.User['database'];
    ActiveBranchId: NAuth.User['activeBranchId'];
  };

  export type GetSelectItemByValue = (
    value: string,
    data: BaseOptionType[]
  ) => object;

  export type AdaptDataToSelect = (
    data:
      | NSmallGlobalEntities.ModelItem[]
      | NBranches.BranchesForSystem[]
      | NDictionaries.ModelCountry[]
  ) => BaseOptionType[];

  export type AdaptDateFromSelects = (
    day: string,
    month: string,
    year: string
  ) => string;

  export type CompareTwoDates = (date1: string, date2: string) => boolean;

  export type AddUserPrintAsParams = (
    userId: NAuth.UserPrint['userId'] | NAuth.UserPrint,
    database?: NAuth.UserPrint['database'],
    activeBranchId?: NAuth.UserPrint['activeBranchId']
  ) => string;

  export type ErrorTypes = 'warning' | 'error' | undefined;

  export type OpenNotificationWithIcon = (args: {
    type: ErrorTypes;
    api: NotificationInstance;
    errorMessage?: string;
  }) => void;

  export type AddEnterKeyListener = (args: { callback: () => void }) => void;

  export type IsSidebarServicePage = (isDebugMode?: boolean) => boolean;

  export type HandlePhoneOnPaste = (
    phoneNumber: string | number,
    telCode: number,
    maskLength: number
  ) => {
    handledPhone: string;
    tip: string;
  };

  export type GetIconObjectById = (
    id: string,
    options?: object
  ) => NConstants.IconObject;

  export type DefineDeployingMode = (
    clientHost: string
  ) => typeof DEV_MODE | typeof PROD_MODE | typeof UNKNOWN_MODE;

  export type DefineAccessTokenName = (
    clientHost: string
  ) => typeof ACCESS_TOKEN | typeof DEV_ACCESS_TOKEN;

  export type GetUniqueCategories = (
    data: NClientServices.ModelBranchClientService[],
    categoryIdKey?: 'CategoryId'
  ) => NClientServices.ModelBranchClientService[];

  export type ImportClientServices = (args: {
    event: { target: HTMLInputElement };
    contentClassName: string;
    setFile: (value: string) => void;
    setExtension: (value: string) => void;
    navigate: (value: string) => void;
  }) => void;

  export type InputValueToCorrectRange = string | undefined | null;

  export type CbToSaveValue = (checkedOutput: InputValueToCorrectRange) => void;

  export type CbToSaveTimeValue = (checkedOutput: BaseOptionType) => void;

  export type CbToSaveBothValues = (
    args: [InputValueToCorrectRange, InputValueToCorrectRange]
  ) => void;

  export type CbToSaveBothTimeValues = (
    args: [BaseOptionType, BaseOptionType]
  ) => void;

  export type CorrectRangeValuesArgs<
    T extends CbToSaveValue,
    U extends CbToSaveBothValues,
    V
  > = {
    inputStart: V;
    inputEnd: V;
    showNotification: NNotificationProvider.ShowNotificationType;
    cbToSaveStartValue?: T;
    cbToSaveEndValue?: T;
    cbToSaveBothValues?: U;
  };

  export type CorrectTimeIntervalArgs<
    T extends CbToSaveTimeValue,
    U extends CbToSaveBothTimeValues,
    V
  > = {
    inputStart: V;
    inputEnd: V;
    showNotification: NNotificationProvider.ShowNotificationType;
    cbToSaveStartValue?: T;
    cbToSaveEndValue?: T;
    cbToSaveBothValues?: U;
  };

  export type CorrectRangeValues = <
    T extends CbToSaveValue,
    U extends CbToSaveBothValues
  >(
    args: CorrectRangeValuesArgs<T, U, InputValueToCorrectRange>
  ) => void;

  export type CorrectTimeInterval = <
    T extends CbToSaveTimeValue,
    U extends CbToSaveBothTimeValues
  >(
    args: CorrectTimeIntervalArgs<T, U, BaseOptionType>
  ) => void;
}
